var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "ml-2 mr-2",
          attrs: { "lazy-validation": "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit($event)
            },
          },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "v-row",
            { staticClass: "pb-0 m-0" },
            [
              _c("v-col", { staticClass: "text-center pb-0" }, [
                _c("p", { staticClass: "mb-0 text-center" }, [
                  _vm._v(
                    " Preencha o formulário abaixo para adicionar um novo cartão "
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "pt-2 pb-0 m-0" },
            [
              _c(
                "v-img",
                {
                  staticStyle: { "border-radius": "30px" },
                  attrs: {
                    src: require("@/assets/cards/images/" +
                      _vm.currentCardBackground +
                      ".jpeg"),
                  },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "white--text pa-5 ma-2",
                      attrs: { color: "transparent elevation-0" },
                    },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "pa-2 pt-2 pb-2",
                          attrs: { justify: "space-between" },
                        },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "8" } },
                            [
                              _c("v-img", {
                                attrs: {
                                  src: require("@/assets/cards/images/chip.png"),
                                  width: "48px",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "pa-2", attrs: { cols: "4" } },
                            [
                              _c("v-img", {
                                staticStyle: {
                                  "max-height": "70px !important",
                                  width: "auto !important",
                                },
                                attrs: {
                                  src: require("@/assets/cards/images/" +
                                    _vm.card_type +
                                    ".png"),
                                  "max-height": "70px",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("v-col", { attrs: { cols: "12" } }, [
                            _c("h3", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.maskCardNumber(_vm.cardNumber) ||
                                      "0000 0000 0000 0000"
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("v-col", { attrs: { cols: "9" } }, [
                            _c("h4", [
                              _vm._v(_vm._s(_vm.cardName || "Nikola Tesla")),
                            ]),
                          ]),
                          _c("v-col", { attrs: { cols: "3" } }, [
                            _vm._v(_vm._s(_vm.expire || "09/25")),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "pt-6 pb-0" },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Nome como está no cartão",
                          required: "",
                          rules: _vm.nameRules,
                          filled: "",
                          rounded: "",
                          autofocus: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.cardName,
                          callback: function ($$v) {
                            _vm.cardName = $$v
                          },
                          expression: "cardName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "pt-0 pb-0", attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: _vm.cardMask,
                            expression: "cardMask",
                          },
                        ],
                        attrs: {
                          type: "tel",
                          rules: _vm.numberRules,
                          label: "Numero do Cartão",
                          placeholder: "####-####-####-####",
                          maxlength: _vm.cardNumberMaxLength,
                          "return-masked-value": "",
                          required: "",
                          filled: "",
                          rounded: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.cardNumber,
                          callback: function ($$v) {
                            _vm.cardNumber = $$v
                          },
                          expression: "cardNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "pt-0 pb-0", attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "##/##",
                            expression: "'##/##'",
                          },
                        ],
                        attrs: {
                          rules: _vm.expireRules,
                          label: "Data de Validade",
                          name: "expire",
                          type: "tel",
                          placeholder: "##/##",
                          "return-masked-value": "",
                          required: "",
                          filled: "",
                          rounded: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.expire,
                          callback: function ($$v) {
                            _vm.expire = $$v
                          },
                          expression: "expire",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "pt-0 pb-2", attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: _vm.cvvMask,
                            expression: "cvvMask",
                          },
                        ],
                        attrs: {
                          type: "password",
                          rules: _vm.cvvRules,
                          label: "Código de Verificação",
                          name: "code",
                          placeholder: "###",
                          required: "",
                          filled: "",
                          rounded: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.cvv,
                          callback: function ($$v) {
                            _vm.cvv = $$v
                          },
                          expression: "cvv",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "body-2 pa-3 pt-2" },
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        type: "info",
                        color: "primary",
                        dense: "",
                        outlined: "",
                      },
                    },
                    [
                      _c("p", { staticClass: "font-weight-bold" }, [
                        _vm._v("Você receberá duas contas separadas"),
                      ]),
                      _vm._v(
                        " No cartão você pagará pela geração da energia limpa para a Juntos. Você continuará pagando a conta da sua concessionária. Mas apenas os custos mínimos e/ou excedentes de consumo, encargos e impostos. "
                      ),
                    ]
                  ),
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        type: "info",
                        color: "primary",
                        dense: "",
                        outlined: "",
                      },
                    },
                    [
                      _vm._v(
                        " Para segurança, nós iremos realizar uma pré autorização no valor de R$1,23 no seu cartão. Isso é apenas para verificação e o valor não será cobrado da sua fatura. "
                      ),
                    ]
                  ),
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        type: "info",
                        color: "primary",
                        dense: "",
                        outlined: "",
                      },
                    },
                    [
                      _vm._v(
                        " Qualquer cobrança no seu cartão de crédito será realiza somente após a efetivação do cadastro e abatimento dos créditos de energia em sua conta de luz. "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm.error_message
                ? _c(
                    "div",
                    {
                      staticClass:
                        "body-2 red--text font-weight-bold text-center pb-3",
                    },
                    [_vm._v(" " + _vm._s(_vm.error_message) + " ")]
                  )
                : _vm._e(),
              _c(
                "v-btn",
                {
                  staticClass: "mr-4 text-none mb-4",
                  attrs: {
                    color: "secondary",
                    type: "submit",
                    disabled: !_vm.valid || _vm.loading,
                    loading: _vm.loading,
                    rounded: "",
                    block: "",
                    large: "",
                  },
                },
                [_vm._v(" " + _vm._s("Cadastrar Cartão") + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }